module.exports = __webpack_public_path__ + "static/img/mlt.f88b635.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/mlt.jpg
// module id = jIRj
// module chunks = 0